import { Fragment } from "react/jsx-runtime";
import { PropertyFieldSection } from "../property-field-section";
import { PropertyFieldSwicher } from "./property-field-switcher";
import { useBreakpointValue } from "@chakra-ui/react";
import { PropertyFieldViewModel } from "../../types/property-field.view-model";
import { usePropertyFields } from "../../providers/property-fields-context";

export function PropertyFieldsReadOnly() {
  const { sections } = usePropertyFields();

  const columns = useBreakpointValue({ base: 1, md: 2 }) ?? 1;

  const ReadOnly = ({ field, index }: { field: PropertyFieldViewModel; index: number }) => {
    const isEvenRow = Math.floor(index / columns) % 2 === 0;
    return <PropertyFieldSwicher key={field.data_key} field={field} isEvenRow={isEvenRow} />;
  };

  return (
    <>
      {sections.map((section, index) => (
        <Fragment key={`${section.title}-${index}`}>
          <PropertyFieldSection title={section.title} kind={section.kind}>
            {section.fields.map((field, index) => {
              return (
                <Fragment key={field.data_key}>
                  <ReadOnly field={field} index={index} />
                </Fragment>
              );
            })}
          </PropertyFieldSection>
        </Fragment>
      ))}
    </>
  );
}
